const words = ["DÖNER", "PIZZA", "DÜRÜM", "LAHMACUN", "FALAFEL", "AYRAN", "STEINOFEN", "FRISCH VOM SPIESS"];

export default function Marquee() {
  const row = [
    ...words.map((w) => ({ w, key: `${w}-a` })),
    ...words.map((w) => ({ w, key: `${w}-b` })),
  ];
  return (
    <div data-testid="marquee-ribbon" className="relative bg-[#e05d36] py-4 overflow-hidden border-y-2 border-black">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map(({ w, key }) => (
          <span key={key} className="mx-6 font-display font-black text-2xl md:text-3xl text-black tracking-tight flex items-center gap-6">
            {w}
            <span className="text-black/50">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
